import {
  createReqConsts,
  createActions,
  createReqReducer,
} from '../../utils/redux';

export const consts = createReqConsts('profiles', 'country-code', ['SET']);
export const actions = createActions(consts);

const requestReducer = createReqReducer(consts);

const initialState = {
  succeed: null,
  error: null,
  rejected: null,
  currentCountryCode: '+1',
};

const clear = state => ({
  ...state,
  ...initialState,
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return clear(state);

    case consts.SET:
      return {
        ...state,
        currentCountryCode: action.payload || 'us',
      };

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/country-code.js